export default __webpack_public_path__ + "792ca665384d73e3642b38a3619fc8ad.png";